(() => {
  if (window.leksTemplateFormsReady) return;
  window.leksTemplateFormsReady = true;
  const update = (container, variant) => {
    const values = {'[data-leks-quote-variant]': variant?.title || '', '[data-leks-quote-id]': variant?.id || '', '[data-leks-quote-sku]': variant?.sku || ''};
    Object.entries(values).forEach(([selector, value]) => { const input = container.querySelector(selector); if (input) input.value = value; });
    const selection = container.querySelector('[data-leks-quote-selection]');
    if (selection) selection.textContent = variant?.title || theme.strings.unavailable;
  };
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (!variant) return;
    document.querySelectorAll('[data-leks-quote-product]').forEach(container => {
      if (container.dataset.variantIds.split(',').includes(String(variant.id))) update(container, variant);
    });
  });
  document.addEventListener('variantChange', event => {
    if (event.detail?.variant) return;
    event.target.querySelectorAll?.('[data-leks-quote-product]').forEach(container => update(container, null));
  }, true);
})();
